<section class="img-container text-center img-fluid my-5">
    <img src="../../../assets/img/thumbnail_Flygets-logo.png" alt="logo" class="d-block margin">
    <div class="centered my-5">
        <h1>Arlandaparkeringar</h1>
        <!-- <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{ 'CONTACT.BACK' | transloco | uppercase}}</button> -->
    </div>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>Flygets Långtidsparkering</h2>
    <p class="lead">Flygets Långtidsparkering ligger direkt i anslutning till avfart 181, Arlandastad. Den
        långtidsparkering som ligger närmast Stockholm, ca 6 minuter från Arlanda Flygplats.</p>
    <p class="lead">
        <b>Adress: </b>Caravellegatan, 196 51 Arlandastad
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Hela parkeringen är asfalterad med tydligt markerade rutor. Totalt 1550 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Automatisk incheckning med registreringnummer. Anvisad parkeringsrad.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt vid avresa och hemresa med upphämtning vid bilen eller i anslutning
        till parkeringsraden.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 650kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.flygets.se" target="_blank">www.flygets.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Benstocken</h2>
    <p class="lead">Benstockens långtidsparkering ligger intill motorvägen som går in till Arlanda flygplats.</p>
    <p class="lead">
        <b>Adress: </b>Starrmossen, 195 96 Rosersberg
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Parkeringen är asfalterad och erbjuder enbart parkering utomhus med tydlig markerade rutor.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Anvisad parkering.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt från hållplats incheckning vid avresa och hemresa.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 590kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.benstocken.se" target="_blank">www.benstocken.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Lindskrog Parkering Arlanda</h2>
    <p class="lead">Lindskrog Parkering Arlanda ligger förbi Arlanda flygplats på väg mot väg 273.</p>
    <p class="lead">
        <b>Adress: </b>Lindskrogsvägen 3, 190 60 Stockholm-Arlanda
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Parkeringen utomhus är till stor del grusad vid utomhusparkering och asfalterad vid
        inomhusparkering. 1050 utomhusparkeringar, 250 inomhusparkeringar.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Anvisad parkering.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt från hållplats incheckning vid avresa och hemresa.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 699kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.lindskrog.se" target="_blank">www.lindskrog.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Måby park</h2>
    <p class="lead">Måby park ligger vid måby industriområde ca 5 minuter från Arlanda. </p>
    <p class="lead">
        <b>Adress: </b>Måby 111, 195 91 Märsta
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Hela parkeringen är asfalterad med tydligt markerade rutor. Totalt 300 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Anvisad parkering.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt från hållplats vid incheckningen vid avresa och hemresa.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 650kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.mabypark.se" target="_blank">www.mabypark.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>ARN Långtidsparkering</h2>
    <p class="lead">ARN Långtidsparkering ligger i Märsta industriområde.</p>
    <p class="lead">
        <b>Adress: </b>Elkraftsgatan 7, 195 60 Arlandastad
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Hela parkeringen är asfalterad med tydligt markerade rutor. ca 450 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Anvisad parkering.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt från hållplats vid incheckningen vid avresa och hemresa.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 695kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.arnlangtidsparkering.se" target="_blank">www.arnlangtidsparkering.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Connect Hotel Arlanda Parkering</h2>
    <p class="lead">Connect Hotel Arlanda Parkering ligger i Arlandastadområdet. </p>
    <p class="lead">
        <b>Adress: </b>Lindberghs gata 10, 195 61, Arlandastad
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Stora delar av parkeringen är asfalterad och en del är grusad. Ca 500 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Ej anvisade platser.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer delar av dygnet från hållplats vid incheckningen vid avresa och hemresa. Avgår
        var 30 minut mellan kl 03.00 till kl 01.10 alla dagar.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 599kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.parkos.se" target="_blank">www.parkos.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Trosta</h2>
    <p class="lead">Trosta parkering finns i Trosta Affärsområde längst med väg 273. </p>
    <p class="lead">
        <b>Adress: </b>Trosta 185, Märsta
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Stora delar av parkeringen är asfalterad och en del är grusad. Ca 500 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Ej anvisade platser.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer delar av dygnet från hållplats vid incheckningen vid avresa och hemresa mellan
        kl 03.00 till kl 23.59 alla dagar.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 650kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.parkos.se" target="_blank">www.parkos.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Apark</h2>
    <p class="lead">Apark är en obevakad parkering vid trafikplats 182. </p>
    <p class="lead">
        <b>Adress: </b>Trosta 185, Märsta
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Parkeringen är en grusyta. Ca 500 parkeringsplatser.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Ingen incheckning.
    </p>
    <p class="lead">
        <b>Transfer: </b>Ingen transfer
    </p>
    <p class="lead">
        <b>Bemanning: </b>Obemannat
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 210kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.apark.se" target="_blank">www.apark.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>



<section class="container">
    <h2>MD Park</h2>
    <p class="lead">MD Park är en takparkering och inhägnat område uppdelat på två platser. </p>
    <p class="lead">
        <b>Adress: </b>Thulins Plats 8f, 195 61 Arlandastad
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Parkeringen är asfalterad.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Anvisad parkering.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer dygnet runt från hållplats vid incheckningen vid avresa och hemresa.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 660kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.parkos.se" target="_blank">www.parkos.se</a> eller <a
            href="https://www.mdpark.se" target="_blank">www.mdpark.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
    <h2>Best Western </h2>
    <p class="lead">Best Westerns parkering ligger i Märsta i samband med Hotell Best Westerns Hotellby.</p>
    <p class="lead">
        <b>Adress: </b>Bristagatan 22, 190 45 Arlanda
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Hela parkeringen är asfalterad.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Manuell incheckning vid disk i samband med infart. Ej anvisade platser.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer från hållplats vid incheckningen vid avresa och hemresa dygnet runt.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka: 690kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.parkos.se" target="_blank">www.parkos.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>


<section class="container">
    <h2>Swedavia</h2>
    <p class="lead">Swedavia har flera olika parkeringar runt Arlanda. Alfa P3, Beta P2, Express</p>
    <p class="lead">
        <b>Adress: </b>Arlanda Flygplats
    </p>
    <p class="lead">
        <b>Parkeringen: </b>Stora delar av parkeringsplatserna är grusade, Alfa och Beta. Större delen av de
        terminalnära parkeringarna är asfalterade och även inomhus.
    </p>
    <p class="lead">
        <b>Incheckning: </b>Automatisk incheckning. Ej anvisade platser.
    </p>
    <p class="lead">
        <b>Transfer: </b>Gratis transfer från hållplats vid incheckningen vid avresa och hemresa dygnet runt.
    </p>
    <p class="lead">
        <b>Bemanning: </b>Dygnet runt alla dagar
    </p>
    <p class="lead">
        <b>Normalpris: </b>1 vecka från 799 kr till 2449 kr
    </p>
    <p class="lead">
        <b>Hemsida: </b><a href="https://www.swedavia.se" target="_blank">www.swedavia.se</a>
    </p>
    <mat-divider class="my-5"></mat-divider>
</section>

<div class="jumbotron jumbotron-fluid mt-4">
    <div class="container">
        <button class="my-3" mat-raised-button routerLink="/flygets/flygets-start">{{ 'CONTACT.BACK' | transloco |
            uppercase}}</button>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT1' | transloco }}</p>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
        <a [routerLink]="['/flygets/kontakta-oss']">{{ 'FLYGETS.CONTACT.FORM' | transloco }}</a><br>
        <a href="mailto: info@flygets.se">info&#64;flygets.se</a><br>
        <a href="tel: 010-330 03 33"> 010-330 03 33</a>
        <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
    </div>
</div>


<app-small-footer></app-small-footer>